import React, { Component } from "react";
import { Container, Card } from "react-bootstrap";
import { applyNavigationEffect } from "../../effects/NavigationEffect";
import CardWithImageComponent from "../../components/CardWithImageComponent.js";
class MidSummerNight extends Component {
  componentDidMount() {
    applyNavigationEffect(); // Call the navigation effect
  }

  render() {
    return (
      <div id="midsummernight">
        <Container className="main-container">
          <CardWithImageComponent
            image="/assets/images/mittsommernacht/2026/sommernacht_01.jpg"
            id="sommernacht"
            className="card-with-image"
          />
          <CardWithImageComponent
            image="/assets/images/mittsommernacht/2026/infoseite.jpg"
            className="card-with-image"
            id="flyer_summernight"
            text="Wir gehen aktuell davon aus, dass die Veranstaltung am Hohenfels stattfindet"
          />
          <CardWithImageComponent
            image="/assets/images/mittsommernacht/2026/flyer-02.jpg"
            className="card-with-image"
            id="flyer_summernight"
            header="Anfahrtsplan"
          />

          <Card>
            <Card.Body className="small-h1" style={{ textAlign: "center" }}>
              <a href="/" style={{ textDecoration: "underline", textAlign: "center" }}>
                Zurück zur Startseite
              </a>
            </Card.Body>
          </Card>
        </Container>
      </div>
    );
  }
}

export default MidSummerNight;
